import * as React from "react";
const SvgAudioIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.5 15.4167V4.16667L17.5 2.5V13.75M7.5 7.5L17.5 5.83333M7.5 15.8333C7.5 16.7538 6.38071 17.5 5 17.5C3.61929 17.5 2.5 16.7538 2.5 15.8333C2.5 14.9129 3.61929 14.1667 5 14.1667C6.38071 14.1667 7.5 14.9129 7.5 15.8333ZM17.5 14.1667C17.5 15.0871 16.3807 15.8333 15 15.8333C13.6193 15.8333 12.5 15.0871 12.5 14.1667C12.5 13.2462 13.6193 12.5 15 12.5C16.3807 12.5 17.5 13.2462 17.5 14.1667Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgAudioIcon;
